import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c101e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionSubmitView" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";
import JudgeInfoMessageEnum from "@/enums/JudgeInfoMessageEnum";
import { QuestionSubmitQueryRequest } from "../../../generated/models/QuestionSubmitQueryRequest";
import { QuestionSubmitControllerService } from "../../../generated/services/QuestionSubmitControllerService";
import { Question } from "../../../generated/models/Question";
import { QuestionControllerService } from "../../../generated";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSubmitView',
  setup(__props) {

document.title="状态"

const router = useRouter();

// 搜索参数
const searchParams = ref<QuestionSubmitQueryRequest>({
  language: "",
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "descend",
});

// 提交记录总数
const total = ref(0);

// 提交记录
const dataList = ref([]);

// 支持语言
const languages = ref<string[]>();

/**
 * 获取提交记录
 */
const loadData = async () => {
  const res =
    await QuestionSubmitControllerService.listQuestionSubmitByPageUsingPost({
      ...searchParams.value,
    });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 监听loadData函数所使用的变量的变化，改变时触发页面的重新加载
 */
watchEffect(() => {
  loadData();
});

onMounted(() => {
  loadData();
  getLanguage();
});

const columns = [
  {
    title: "提交号",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "编程语言",
    dataIndex: "language",
    align: "center",
  },
  {
    title: "判题信息",
    children: [
      {
        title: "判题结果",
        slotName: "message",
        align: "center",
        width: 100,
      },
      {
        title: "内存消耗",
        slotName: "memory",
        align: "center",
        width: 100,
      },
      {
        title: "时间消耗",
        slotName: "time",
        align: "center",
        width: 100,
      },
    ],
  },
  {
    title: "提交状态",
    slotName: "status",
    align: "center",
  },
  {
    title: "题目",
    slotName: "questionTitle",
    align: "center",
  },
  {
    title: "提交者",
    slotName: "userName",
    align: "center",
  },
  {
    title: "提交时间",
    slotName: "createTime",
    align: "center",
  },
];

/**
 * 跳转到做题页面
 * @param question
 */
const toDoQuestion = (question: Question) => {
  router.push({
    path: `/view/question/${question.id}`,
  });
};

/**
 * 页面切换
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 页面大小切换
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

/**
 * 搜索函数
 */
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
  // loadData();
};

/**
 * 从后端获取支持语言
 */
const getLanguage = async () => {
  // 从后端获取支持语言
  const res = await QuestionControllerService.getCodeLanguageUsingGet();
  if (res.code === 0) {
    languages.value = res.data;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { field: "language" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: searchParams.value.language,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.language) = $event)),
              style: {"width":"300px","border-radius":"10px"},
              placeholder: "选择语言",
              "allow-clear": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                  return (_openBlock(), _createBlock(_component_a_option, { key: language }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(language), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              shape: "round",
              status: "normal",
              onClick: loadData
            }, {
              default: _withCtx(() => [
                _createTextVNode("刷新 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_divider, { size: "0" }),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        current: searchParams.value.current,
        pageSize: searchParams.value.pageSize,
        total: total.value,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      message: _withCtx(({ record }) => [
        (record.judgeInfo.message === _unref(JudgeInfoMessageEnum).ACCEPTED)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "blue",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
              ]),
              _: 2
            }, 1024))
          : (record.judgeInfo.message === _unref(JudgeInfoMessageEnum).WAITING)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                color: "green",
                bordered: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(_component_a_tag, {
                key: 2,
                color: "red",
                bordered: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                ]),
                _: 2
              }, 1024))
      ]),
      memory: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.judgeInfo.memory ? record.judgeInfo.memory : 0) + " K ", 1)
      ]),
      time: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.judgeInfo.time ? record.judgeInfo.time : 0) + " ms ", 1)
      ]),
      status: _withCtx(({ record }) => [
        (record.status === 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "gray"
            }, {
              default: _withCtx(() => [
                _createTextVNode("待判题")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 1)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "arcoblue"
            }, {
              default: _withCtx(() => [
                _createTextVNode("判题中")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 2)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              color: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode("已判题")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 3)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              color: "red"
            }, {
              default: _withCtx(() => [
                _createTextVNode("失败")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      questionTitle: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "text",
          onClick: ($event: any) => (toDoQuestion(record.questionVO))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.questionVO.title), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      userName: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.userVO?.userName ? record.userVO?.userName : "无名者"), 1)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})